import React from 'react'
import { useIntl } from 'react-intl'

import PriceLayout, { FeaturedPrice } from '../../../PriceLayout'
import type { OfferPriceProps } from '../types'

export interface OfferPriceAllInProps extends OfferPriceProps {
  featuredPrice?: FeaturedPrice
}

const OfferPriceAllIn = ({
  className,
  board,
  nights,
  priceData,
  prime = false,
  showDiscount,
  showDiscountBadge,
  showFrom,
  showSubtitle,
  featuredPrice = FeaturedPrice.Total,
  loading = false,
}: OfferPriceAllInProps) => {
  const intl = useIntl()

  const {
    currency,
    discount,
    pricePerNightWithFees,
    initialPrice,
    totalWithFees,
    taxDetails,
    additionalFees,
    insuranceSelected,
  } = board

  return (
    <PriceLayout
      className={className}
      currency={currency}
      discount={discount}
      pricePerNight={pricePerNightWithFees}
      priceInitial={initialPrice}
      priceFinal={totalWithFees}
      vats={intl.formatMessage({ id: 'net.price-total-taxes-included' })}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      nights={nights}
      featuredPrice={featuredPrice}
      loading={loading}
      showSubtitle={showSubtitle}
      taxDetails={taxDetails}
      additionalFees={additionalFees}
      insuranceSelected={insuranceSelected}
    />
  )
}

export default OfferPriceAllIn
